module.exports = __webpack_public_path__ + "static/media/test-bg.a84a64fd.svg";